export default "__VITE_ASSET__OHwr2HfP__"